import { render } from "./AreaActivityReport.vue?vue&type=template&id=dc2fb3ec"
import script from "./AreaActivityReport.vue?vue&type=script&lang=js"
export * from "./AreaActivityReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__